import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";
import AgentSentimentFiltersDialog from "./AgentSentimentFiltersDialog";

interface ISentimentFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function AgentSentimentFilters({ callTableViewModel, setCallTableViewModel }: ISentimentFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                'Agent'
            }
            {
                (callTableViewModel.filters.agentSentimentFilters.isStartingSentimentEnabled ||
                    callTableViewModel.filters.agentSentimentFilters.isMiddleSentimentEnabled ||
                    callTableViewModel.filters.agentSentimentFilters.isFinalSentimentEnabled) ?
                    ` - Sentiment Active` : ''
            }
            {
                (callTableViewModel.filters.agentSentimentFilters.isStartingMoodEnabled ||
                    callTableViewModel.filters.agentSentimentFilters.isMiddleMoodEnabled ||
                    callTableViewModel.filters.agentSentimentFilters.isFinalMoodEnabled) ?
                    ` - Mood Active` : ''
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <AgentSentimentFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel} />
        </>
    )
}